(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["usp-banner"] && !Shopify.designMode) return;
  try {
    
$('.usp-banner').slick({
  dots: false,
  arrows: false,
  autoplay: true,
  autoplaySpeed: 3000,
  slidesToShow: 2,
  slidesToScroll: 2,
	mobileFirst: true,
	responsive: [
{
      breakpoint: 768,
settings: "unslick"
      },
    {
      breakpoint: 100,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      },
    }
  ]
});
document.addEventListener("shopify:section:load", function() {
  $('.usp-banner').slick({
    dots: false,
  arrows: false,
  autoplay: true,
  autoplaySpeed: 3000,
  slidesToShow: 2,
  slidesToScroll: 2,
	mobileFirst: true,
	responsive: [
{
      breakpoint: 800,
settings: "unslick"
      },
    {
      breakpoint: 100,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      },
    }
  ]
});
});


  } catch(e) { console.error(e); }
})();
})();
